import script from "./password-interrupt.vue?vue&type=script&setup=true&lang=ts"
export * from "./password-interrupt.vue?vue&type=script&setup=true&lang=ts"

import "./password-interrupt.vue?vue&type=style&index=0&id=61e896eb&scoped=true&lang=css"

import exportComponent from "/tmp/workspace/b-client-workspace_release_3.0.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61e896eb"]])

export default __exports__